// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-row {
    /* Define your selected row styles here */
    background-color: #2aada06e; /* Change this to the background color you want */
  }
  
  .selected-row:hover {
    /* Styles for the selected row on hover */
    background-color: #2aada06e; /* Change this to the hover background color you want */
    cursor: pointer; /* Show a pointer cursor on hover */
    /* Add any other hover styles you'd like */
  }

  .pointer {
    cursor: pointer;
  }

  /* AllCirculars.css */
.pdf-container {
    width: 100% !important;
    height: 90% !important;
   
    justify-content: center;
}

.pdf-document {
    max-width: 100% !important;
    height: 100% !important; /* or set a specific height as needed */
}


`, "",{"version":3,"sources":["webpack://./src/pages/AllCirculars.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,2BAA2B,EAAE,iDAAiD;EAChF;;EAEA;IACE,yCAAyC;IACzC,2BAA2B,EAAE,uDAAuD;IACpF,eAAe,EAAE,mCAAmC;IACpD,0CAA0C;EAC5C;;EAEA;IACE,eAAe;EACjB;;EAEA,qBAAqB;AACvB;IACI,sBAAsB;IACtB,sBAAsB;;IAEtB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB,EAAE,uCAAuC;AACpE","sourcesContent":[".selected-row {\r\n    /* Define your selected row styles here */\r\n    background-color: #2aada06e; /* Change this to the background color you want */\r\n  }\r\n  \r\n  .selected-row:hover {\r\n    /* Styles for the selected row on hover */\r\n    background-color: #2aada06e; /* Change this to the hover background color you want */\r\n    cursor: pointer; /* Show a pointer cursor on hover */\r\n    /* Add any other hover styles you'd like */\r\n  }\r\n\r\n  .pointer {\r\n    cursor: pointer;\r\n  }\r\n\r\n  /* AllCirculars.css */\r\n.pdf-container {\r\n    width: 100% !important;\r\n    height: 90% !important;\r\n   \r\n    justify-content: center;\r\n}\r\n\r\n.pdf-document {\r\n    max-width: 100% !important;\r\n    height: 100% !important; /* or set a specific height as needed */\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
